<template>
    <q-page class="q-pa-md">
        Forbidden
    </q-page>
</template>

<script>
    export default {
        data() {
            return {
            }
        }
    }
</script>
